import { Fragment, useEffect } from 'react';

import { vacancyStatisticsHHLink } from 'utils/clickme';

import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import Spinner from 'components/Spinner';
import Table from 'components/Table';
import TitlePage from 'components/TitlePage';

import Filter from 'components/Statistic/Filter';
import fetchStatistics from 'components/Statistic/Filter/fetchStatistics';
import Header from 'components/Statistic/Header';
import Item from 'components/Statistic/Item';
import TableBody from 'components/Table/TableBody';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Statistic/Statistic.less';

const StatisticBody = () => {
    const { isLoad, items, objectName, bannerId, showCr, showResponsesAndCr, vacancyId, headers } = useSelector(
        (state) => state.statistics
    );
    const trl = useTrls();

    const header = `${trl(bannerId ? 'statistic.banner.title.text' : 'statistic.campaign.title.text')}«${objectName}»`;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchStatistics());
    }, [dispatch]);
    return (
        <Fragment>
            <TitlePage header={header} dataQa="page_title" />
            <Gap bottom>
                <Filter />
            </Gap>
            {vacancyId !== 0 && (
                <Gap bottom>
                    <div className="statistic-hint">
                        <p className="statistic-hint__item">{trl('statistic.hint1')}</p>
                        <p className="statistic-hint__item">
                            {trl('statistic.hint2')}
                            <a href={vacancyStatisticsHHLink(vacancyId)}>{trl('statistic.hint.link')}</a>
                            {trl('statistic.hint3')}
                        </p>
                        <p className="statistic-hint__item">{trl('statistic.hint4')}</p>
                    </div>
                </Gap>
            )}
            {!isLoad && (
                <Table bordered fullWidth withStripes>
                    <Header />
                    <TableBody>
                        {items.total && (
                            <Item
                                {...items.total}
                                isTotal
                                showCr={showCr}
                                showResponsesAndCr={showResponsesAndCr}
                                headers={headers}
                            />
                        )}
                        {items.stats.map((item) => (
                            <Item
                                key={item.date}
                                {...item}
                                showCr={showCr}
                                showResponsesAndCr={showResponsesAndCr}
                                headers={headers}
                            />
                        ))}
                    </TableBody>
                </Table>
            )}
            {isLoad && <Spinner />}
        </Fragment>
    );
};

export default StatisticBody;
